import React from "react";

export const Card = React.forwardRef(({ Logo, Qrcode, Caption, Name }, ref) => {
  return (
      <div ref={ref} className="card shadow bg-light m-4">
        <div className="d-flex justify-content-between m-3">
          <div style={{ width: "50%" }}>
            <h3>{Name !== "" ? Name : "Business name"}</h3>
            <small className="text-muted">
              {Caption !== ""
                ? Caption
                : "Dealers in the best laptops and accessories"}
            </small>
            <div className="mt-3">
              <img
              id="logoimg"
                style={{ width: "30px", height: "30px" }}
                src={Logo !=='' ? Logo : require("../assets/Tailwind_CSS_Logo.svg.png")}
                alt="logo"
              />
            </div>
          </div>
          <img
            id="myimg"
            src={Qrcode !=='' ? Qrcode : require("../assets/qrcode(1).png")}
            style={{ width: "8rem" }}
            alt="Preview will appear here..."
          />
        </div>
      </div>
  );
})